import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_GATEWAY_PATH, CheckoutGetPermissionResponse } from '@impact/data';

@Injectable({
    providedIn: 'root'
})
export class ConsentService {
    constructor(private http: HttpClient) {}

    getCheckoutConsentText() {
        const url = `/${API_GATEWAY_PATH}/Consent/GetCheckoutConsentText`;

        return this.http.get<CheckoutGetPermissionResponse>(url);
    }
}
